export default "__VITE_ASSET__5Pg8bb6T__"